import {
  ApiResponse,
  InitOverrideFunction,
  TranslatorApi,
  TranslatorCancelTranslationPostRequest,
  TranslatorTranslateFilePostRequest,
  TranslatorTranslateTextPostRequest,
  TranslatorTranslateWithGlossaryTextPostRequest,
} from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { TranslationApiService } from "../ApiServices/TranslationApiService";
import GenericService from "../GenericService";

export class TranslationService extends GenericService<TranslatorApi, TranslationApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, TranslatorApi, TranslationApiService);
  }

  public translateFile(
    request: TranslatorTranslateFilePostRequest,
    overrides: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.apiService.translatorTranslateFilePostRaw(request, overrides);
  }

  public translateText(
    request: TranslatorTranslateTextPostRequest,
    overrides: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.apiService.translatorTranslateTextPostRaw(request, overrides);
  }

  public translateTextWithGlossary(
    request: TranslatorTranslateWithGlossaryTextPostRequest,
    overrides: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.apiService.translatorTranslateTextWithGlossaryPostRaw(request, overrides);
  }

  public cancelActiveTranslation(request: TranslatorCancelTranslationPostRequest): Promise<string> {
    return this.apiService.translatorCancelTranslationPost(request);
  }
}
